import React from 'react';
import TopBar from '../components/TopBar';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

const DataWarehouse = ({ userClaims, isEmbedded = false }) => {
  const content = (
    <div className="p-4">
      <div className="bg-white shadow-md rounded-lg p-4">
        <h2 className="text-xl font-bold text-gray-800 mb-4">THRIVE360 Data Warehouse</h2>

        {/* Swagger UI embedded here */}
        <SwaggerUI url="https://uni-func-pd-thrive360.azurewebsites.net/api/swagger.json" />
      </div>
    </div>
  );

  if (isEmbedded) return content;

  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="data-warehouse" userClaims={userClaims} />
      {content}
    </div>
  );
};

export default DataWarehouse;
